import React, { useState } from 'react';
import { displayActivityName } from '../utils/activities';
import ModalBackdrop from './ModalBackdrop';

// Renders the "?" info trigger for the Recent Activities calories column,
// the "About Calories Burned" popup, and the "MET Values by Activity" popup.
// Owns both popup toggles internally. The trigger renders inline where the
// component is placed; the popup overlays are rendered via ModalBackdrop,
// which handles the portal, dismissal-on-backdrop-click, and ESC key.
// When MET is opened from within Calories, both popups mount simultaneously;
// a single ESC press closes both layers.
function CaloriesInfoPopup({ currentWeight, calorieBurnRates }) {
  const [showCaloriesPopup, setShowCaloriesPopup] = useState(false);
  const [showMETPopup, setShowMETPopup] = useState(false);

  return (
    <>
      <sup>
        <span
          className="calories-info-link"
          onClick={() => setShowCaloriesPopup(true)}
          style={{ cursor: 'pointer', color: '#007bff', marginLeft: '3px' }}
        >
          ?
        </span>
      </sup>
      {showCaloriesPopup && (
        <ModalBackdrop onClose={() => setShowCaloriesPopup(false)}>
          <div className="popup-content">
            <h3>About Calories Burned</h3>
            <p>
              Calories burned are calculated based on the activity type, duration, weight lifted, and your weight. We use a base calorie burn rate per minute for each activity (e.g., 6 cal/min for Weightlifting), assuming a 155-lb person. This rate is scaled by your weight: Calories = Base Rate × Time × (Your Weight / 155) × (1 + Weight Lifted / 1000). If your weight isn’t logged, we use the base rate for a 155-lb person.
            </p>
            <p>
            <button className="btn-primary" onClick={() => setShowMETPopup(true)}>View MET Values</button>
            </p>
            <button className="btn-secondary" onClick={() => setShowCaloriesPopup(false)}>Close</button>
          </div>
        </ModalBackdrop>
      )}
      {showMETPopup && (
        <ModalBackdrop onClose={() => setShowMETPopup(false)}>
          <div className="popup-content all-activities-popup">
            <div className="popup-header">
              <h3>MET Values by Activity</h3>
              <button
                className="popup-close-button btn-secondary"
                onClick={() => setShowMETPopup(false)}
              >
                Close
              </button>
            </div>
            <p>
              MET (Metabolic Equivalent of Task) values represent the energy cost of activities, scaled by your weight. Your current weight is {currentWeight || 'N/A'} lbs (using 155 lbs if not logged). Below are MET values adjusted for your weight compared to a 155-lb baseline.
            </p>
            <i><p>In simple terms, this number shows how many calories you burn per minute doing each activity.</p></i>
            <div className="table-container">
              <div className="table-wrapper">
                <table className="met-table">
                  <thead>
                    <tr className="activity-headers">
                      <th className="header-cell">Activity</th>
                      <th className="header-cell">MET Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(calorieBurnRates).map(activity => (
                      <tr key={activity} className="activity-record">
                        <td className="record-cell">{displayActivityName(activity)}</td>
                        <td className="record-cell">
                          {(calorieBurnRates[activity] * (parseFloat(currentWeight) || 155) / 155).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
           <button className="btn-secondary" onClick={() => setShowMETPopup(false)}>Close</button>
          </div>
        </ModalBackdrop>
      )}
    </>
  );
}

export default CaloriesInfoPopup;
